package one.healthium.ui.compose.back_handler

import androidx.compose.runtime.staticCompositionLocalOf

fun interface AppBackPressHandler {
    fun onBackPressed()
}

val LocalBackPressHandler = staticCompositionLocalOf<AppBackPressHandler?> { null }